__turbopack_context__.v({
  "app_light_theme": "RegionModalContent-module-scss-module__HIamRa__app_light_theme",
  "link": "RegionModalContent-module-scss-module__HIamRa__link",
  "list": "RegionModalContent-module-scss-module__HIamRa__list",
  "regionNav": "RegionModalContent-module-scss-module__HIamRa__regionNav",
});
